import { CalcIcon } from "./CalcIcon";
import "./calculadora.css";

/* Tela inicial da Calculadora — visão geral + atalhos pras 3 áreas
   (Calculadora / Orçamentos / Histórico), sem misturar tudo numa tela só. */
export function TelaInicio({ onIrCalculadora, onIrNovoOrcamento, onIrOrcamentos, onIrHistorico }) {
  return (
    <section className="calc-home" aria-labelledby="calc-home-title">
      <header>
        <span className="calc-eyebrow">DO MODELO À VENDA</span>
        <h2 id="calc-home-title">Quanto vale sua impressão?</h2>
        <p>Calcule com confiança. Transforme cada peça em uma proposta.</p>
      </header>
      <button type="button" className="calc-home-primary" onClick={onIrCalculadora}>
        <span className="calc-home-icon"><CalcIcon name="calculator" size={26} /></span>
        <span><strong>Abrir calculadora</strong><small>Custos, preço e lucro em tempo real</small></span>
        <CalcIcon name="chevron" />
      </button>
      <div className="calc-home-grid">
        <button type="button" onClick={onIrNovoOrcamento}>
          <CalcIcon name="plus" size={23} /><strong>Novo orçamento</strong><small>Monte uma proposta</small>
        </button>
        <button type="button" onClick={onIrOrcamentos}>
          <CalcIcon name="receipt" size={23} /><strong>Meus orçamentos</strong><small>Acompanhe seus clientes</small>
        </button>
      </div>
      <button type="button" className="calc-home-history" onClick={onIrHistorico}>
        <CalcIcon name="history" /><span>Histórico de cálculos</span><CalcIcon name="chevron" size={15} />
      </button>
      <p className="calc-home-tip"><CalcIcon name="upload" />Comece do zero ou importe do MakerWorld, 3MF ou GCODE.</p>
    </section>
  );
}
